<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <div>
                  <vs-input
                    v-validate="'required|alpha_num|min:4'"
                    data-vv-validate-on="input|keyup|blur|click"
                    name="userName"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="User Name"
                    v-model="userName"
                    class="w-full"
                  />
                  <span class="text-danger text-sm">
                    {{ errors.first("userName") }}
                  </span>
                  <vs-input
                    data-vv-validate-on="input|keyup|blur|click"
                    v-validate="'required|min:6|max:10'"
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    v-model="password"
                    class="w-full mt-6"
                    @keypress.enter="login()"
                  />
                  <span class="text-danger text-sm">
                    {{ errors.first("password") }}
                  </span>
                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                      >Remember Me</vs-checkbox
                    >
                  </div>
                  <div class="flex flex-wrap justify-between mb-3">
                    <vs-button :disabled="!validateForm" @click="login"
                      >Login</vs-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      userName: "",
      password: "",
      checkbox_remember_me: true
    };
  },
  created: function() {
    if (localStorage.getItem("sessionToken") === null) {
      localStorage.clear();
    } else if (localStorage.getItem("sessionToken") !== null) {
      this.$router.push("/").catch(() => {});
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.userName != "" && this.password != "";
    }
  },
  methods: {
    login() {
      this.$vs.loading();
      axios
        .post("https://apianalytics.srisainadhtransport.in/api/core/userAuth", {
          // .post("http://localhost:8000/api/core/userAuth", {
          userName: this.userName,
          password: this.password
        })
        // this.$http.post('core/userAuth',{userName:this.userName,password:this.password})
        .then(response => {
          this.$vs.loading.close();
          if (response.data.data.length > 0) {
            console.log(response);
            this.$vs.notify({
              title: "Success",
              text: response.data.message,
              color: "success",
              iconPack: "feather",
              icon: "icon-check"
            });
            // this.$router.push("/").catch(() => {});
            localStorage.setItem(
              "sstUnData",
              JSON.stringify(response.data.data[0])
            );
            localStorage.setItem(
              "sessionToken",
              response.data.data[0].sessionId
            );
            setTimeout(() => {
              window.location.href = ""; //Will take you to Dashboard.
            }, 500);
          } else {
            this.$vs.notify({
              title: "Error",
              text: response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger"
            });
            this.userName = "";
            this.password = "";
          }
        })
        .catch(error => {
          // this.errorMessage = error.message;
          console.error("There was an error!", error);
        });
    }
  }
};
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;
}
</style>
